class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.animations = null;

    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));

    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  onMouseEnter() {
    document.querySelectorAll('details[open]').forEach(d => {
      if (d !== this.mainDetailsToggle) {
        d.removeAttribute('open');
        const s = d.querySelector('summary');
        s?.setAttribute('aria-expanded', 'false');
        s?.nextElementSibling
          ?.getAnimations()
          .forEach(a => a.cancel());
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');

    if (!this.animations) {
      this.animations = this.content.getAnimations();
    }
    this.animations.forEach(a => a.play());
  }

  onDocumentClick(event) {
    if (
      this.mainDetailsToggle.hasAttribute('open') &&
      !this.contains(event.target)
    ) {
      this.close();
    }
  }

  close() {
    if (!this.animations) {
      this.animations = this.content.getAnimations();
    }
    this.animations.forEach(a => a.cancel());
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);


class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = this.closest('header');

    this.onHeaderMouseLeave = this.onHeaderMouseLeave.bind(this);

    if (this.header) {
      this.header.addEventListener('mouseleave', this.onHeaderMouseLeave);
    }
  }

  onMouseEnter() {
    super.onMouseEnter();
    if (this.header) {
      this.header.preventHide = true;
      if (
        !document.documentElement.style.getPropertyValue(
          '--header-bottom-position-desktop'
        )
      ) {
        const bottom = Math.floor(
          this.header.getBoundingClientRect().bottom
        );
        document.documentElement.style.setProperty(
          '--header-bottom-position-desktop',
          `${bottom}px`
        );
      }
    }
  }
  onHeaderMouseLeave() {
    this.close();
  }

  close() {
    super.close();
    if (this.header) {
      this.header.preventHide = false;
    }
  }
}

customElements.define('header-menu', HeaderMenu);
